import { AuthenticationState } from "bernie-context";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import * as md5 from "md5";

export function mapContext(context: ExtendedContextStore) {
  const {
    currency,
    deviceInformation,
    user: { authState, expUserId, isRegistered, tuid }
  } = context;

  const expediaUserId = expUserId && expUserId !== -1 ? expUserId.toString() : "";
  const publisherTuId = tuid && tuid !== -1 ? tuid.toString() : "";
  let displayFormatType = "Desktop";
  if (deviceInformation) {
    if (deviceInformation.tablet) {
      displayFormatType = "Tablet";
    } else if (deviceInformation.mobile) {
      displayFormatType = "Mobile";
    }
  }

  return {
    display_format_type: displayFormatType,
    is_logged_in_user: authState === AuthenticationState.ANONYMOUS ? "N" : "Y",
    is_member: isRegistered ? "Y" : "N",
    site_currency: currency || "",
    user_member_id: expediaUserId,
    publisher_member_id: publisherTuId,
    publisher_member_id_hashed: md5(publisherTuId),
    expedia_id: expediaUserId,
    expedia_id_hashed: md5(expediaUserId),
    page_id: "homepage.hotels",
    show_exit_units: "Y",
    site_reporting_value_06: "homepage",
    screen_height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
    screen_pixel_depth: window.screen.colorDepth,
    screen_width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    time_zone_offset: new Date().getTimezoneOffset() * -1,
    cache_buster: Math.floor(Math.random() * 10000000),
    trigger_exit_unit: "N",
    show_ads: "N",
    is_signed_up_for_promo_email: "N"
  };
}
